// extracted by mini-css-extract-plugin
module.exports = {"form":"sign-up-form_form__YEjuc","namesRow":"sign-up-form_namesRow__Y9uZu"};